import { render, staticRenderFns } from "./ChooseCompany.vue?vue&type=template&id=6f1bdc86&scoped=true"
import script from "./ChooseCompany.vue?vue&type=script&lang=ts"
export * from "./ChooseCompany.vue?vue&type=script&lang=ts"
import style0 from "./ChooseCompany.vue?vue&type=style&index=0&id=6f1bdc86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1bdc86",
  null
  
)

export default component.exports